module.exports = __webpack_public_path__ + "static/media/aircombat_ex1.7dbf8621.gif";